export default (input: Record<string, string> = {}) => Object.keys(input).some(key => !input[key])